import * as React from 'react';
import { AssignUserViewStore } from 'nomst/Stores/Configuration/assignUserView.store';
import { AssignedUserLevel }
    from 'typings/enums';
import { workflowSettingsViewStore } from 'utils/MobxDataManager/singletons';

interface IHrRolesReviewerLinkProps {
    assignUserViewStore: AssignUserViewStore;
    assignedUserLevel: AssignedUserLevel;
    accessGroupDisplayName?: string;
    readonly?: boolean;
}

export default class HrRolesReviewerLink extends React.Component<IHrRolesReviewerLinkProps> {
    constructor(props: IHrRolesReviewerLinkProps) {
        super(props);
        this.handleReviewerLinkClick = this.handleReviewerLinkClick.bind(this);
        this.assignUser = this.assignUser.bind(this);
    }

    render(): React.ReactNode {
        const { readonly } = this.props;
        if (readonly) {
            return null;
        }

        return (
            <td className="pxl-text-right">
                <button className="pxl-link" onClick={this.assignUser}>Change</button>
                &nbsp;|&nbsp;
                <button
                    className="pxl-link"
                    onClick={this.handleReviewerLinkClick}
                >Remove
                </button>
            </td>
        );
    }

    private assignUser(): void {
        const { assignUserViewStore } = this.props;
        assignUserViewStore.assignUser();
    }

    private handleReviewerLinkClick(): void {
        const {
            assignUserViewStore,
            assignedUserLevel,
            accessGroupDisplayName
        } = this.props;
        workflowSettingsViewStore.removeAssignedUserStore.showRemoveAssignedUserWarningBox(
            assignUserViewStore.selectedUserId ?? '',
            assignedUserLevel,
            accessGroupDisplayName);
    }
}